(function () {
  function initVideoReviewCarousel(sectionRoot) {
    const modalId = sectionRoot.dataset.modalId;
    const modalVideoId = sectionRoot.dataset.modalVideoId;
    const splideSelector = sectionRoot.dataset.splideSelector || '.splide';
    const splideMountedEvent = sectionRoot.dataset.splideMountedEvent || '';

    const modalEl = document.getElementById(modalId);
    const modalVideo = document.getElementById(modalVideoId);
    const videoReviewLinks = sectionRoot.querySelectorAll('.video-review-item-link');

    if (!modalEl || !modalVideo || videoReviewLinks.length === 0) return;

    if (modalEl.parentNode !== document.body) {
      document.body.appendChild(modalEl);
    }

    function isTouchPlaybackDevice() {
      return (
        window.matchMedia('(pointer: coarse)').matches ||
        window.matchMedia('(max-width: 767.98px)').matches ||
        /Android|webOS|iPhone|iPad|iPod|CriOS|FxiOS|EdgiOS/i.test(navigator.userAgent)
      );
    }

    const canHoverPreview = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const previewWrappers = sectionRoot.querySelectorAll('.video-review-item-wrapper');
    let hoverLock = false;
    let viewportAutoplayEnabled = true;
    let mobileExpandedPlayback = false;
    let carouselSplide = null;
    let clickedLink = null;
    let resumeCarouselWrapper = null;
    let modalCarouselWrapper = null;
    let modalStartTime = 0;

    function setActivePreview(wrapper) {
      if (!wrapper) return;
      previewWrappers.forEach(function (w) {
        const video = w.querySelector('.video-review-item-preview');
        if (!video) return;
        if (w === wrapper) {
          w.classList.add('is-preview-playing');
          video.play().catch(function () {});
        } else {
          w.classList.remove('is-preview-playing');
          video.pause();
        }
      });
    }

    function clearAllPreviews() {
      previewWrappers.forEach(function (w) {
        w.classList.remove('is-preview-playing');
        const video = w.querySelector('.video-review-item-preview');
        if (video) video.pause();
      });
    }

    function getVisibilityElement(wrapper) {
      return wrapper.closest('.splide__slide') || wrapper;
    }

    function getVisibleRatio(el) {
      const rect = el.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return 0;
      const top = Math.max(rect.top, 0);
      const left = Math.max(rect.left, 0);
      const bottom = Math.min(rect.bottom, window.innerHeight);
      const right = Math.min(rect.right, window.innerWidth);
      const visibleW = Math.max(0, right - left);
      const visibleH = Math.max(0, bottom - top);
      return (visibleW * visibleH) / (rect.width * rect.height);
    }

    function isFirstPreviewPending() {
      const firstWrapper = previewWrappers[0];
      if (!firstWrapper) return false;
      const firstVideo = firstWrapper.querySelector('.video-review-item-preview');
      if (!firstVideo || firstVideo.readyState >= 1) return false;
      return getVisibleRatio(getVisibilityElement(firstWrapper)) >= 0.25;
    }

    function getPrimaryVisibleWrapper() {
      const minRatio = isTouchPlaybackDevice() ? 0.35 : 0.5;

      if (!isTouchPlaybackDevice() && isFirstPreviewPending()) return null;

      for (let i = 0; i < previewWrappers.length; i++) {
        const wrapper = previewWrappers[i];
        if (getVisibleRatio(getVisibilityElement(wrapper)) >= minRatio) return wrapper;
      }

      return null;
    }

    function getSplideActiveWrapper() {
      if (!carouselSplide || !carouselSplide.Components || !carouselSplide.Components.Slides) return null;
      const slide = carouselSplide.Components.Slides.getAt(carouselSplide.index);
      if (!slide || !slide.slide) return null;
      return slide.slide.querySelector('.video-review-item-wrapper');
    }

    function getAutoplayWrapper() {
      if (isTouchPlaybackDevice()) {
        return getSplideActiveWrapper() || getPrimaryVisibleWrapper();
      }
      return getPrimaryVisibleWrapper();
    }

    function updateViewportAutoplay() {
      if (hoverLock || mobileExpandedPlayback) return;
      if (!isTouchPlaybackDevice() && !viewportAutoplayEnabled) return;

      const wrapper = getAutoplayWrapper();
      if (wrapper) setActivePreview(wrapper);
      else clearAllPreviews();
    }

    function getCarouselPlayingWrapper() {
      for (let i = 0; i < previewWrappers.length; i++) {
        if (previewWrappers[i].classList.contains('is-preview-playing')) return previewWrappers[i];
      }
      return null;
    }

    function pauseAllCarouselPreviews() {
      previewWrappers.forEach(function (w) {
        const video = w.querySelector('.video-review-item-preview');
        if (video) video.pause();
      });
    }

    function restoreMobilePreviewToCarousel(video, wrapper, shouldUpdateAutoplay) {
      if (!video || !wrapper) return;
      video.pause();
      video.muted = true;
      video.loop = true;
      video.setAttribute('muted', '');
      video.removeAttribute('controls');
      wrapper.classList.remove('is-preview-playing');
      if (shouldUpdateAutoplay) requestAnimationFrame(updateViewportAutoplay);
    }

    function resetMobileExpandedPreviews() {
      if (!isTouchPlaybackDevice()) return;
      mobileExpandedPlayback = false;
      previewWrappers.forEach(function (w) {
        const video = w.querySelector('.video-review-item-preview');
        if (video && video.hasAttribute('controls')) restoreMobilePreviewToCarousel(video, w, false);
      });
    }

    function cleanupMobilePreviewPlayback(video, wrapper) {
      mobileExpandedPlayback = false;
      restoreMobilePreviewToCarousel(video, wrapper, true);
    }

    function openMobilePreviewPlayback(previewVideo, wrapper) {
      if (!previewVideo || !wrapper) return;

      mobileExpandedPlayback = true;
      modalCarouselWrapper = wrapper;
      pauseAllCarouselPreviews();

      previewWrappers.forEach(function (w) {
        w.classList.remove('is-preview-playing');
      });

      previewVideo.muted = false;
      previewVideo.loop = false;
      previewVideo.removeAttribute('muted');
      previewVideo.setAttribute('controls', '');
      wrapper.classList.add('is-preview-playing');

      const startTime = Number.isFinite(previewVideo.currentTime) ? previewVideo.currentTime : 0;

      previewVideo
        .play()
        .then(function () {
          if (startTime > 0) previewVideo.currentTime = startTime;
          if (typeof previewVideo.webkitEnterFullscreen === 'function') {
            previewVideo.webkitEnterFullscreen();
          } else if (previewVideo.requestFullscreen) {
            return previewVideo.requestFullscreen();
          }
        })
        .catch(function () {
          mobileExpandedPlayback = false;
          updateViewportAutoplay();
        });
    }

    function closeModalIfOpen() {
      const bsModal = bootstrap.Modal.getInstance(modalEl);
      if (bsModal && modalEl.classList.contains('show')) bsModal.hide();
    }

    function handleDocumentFullscreenExit() {
      const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (fsEl) return;
      closeModalIfOpen();
    }

    function resumeCarouselPreview(modalEndTime) {
      const wrapper = modalCarouselWrapper || resumeCarouselWrapper;
      const endTime = Number.isFinite(modalEndTime) ? modalEndTime : 0;

      if (wrapper) {
        const preview = wrapper.querySelector('.video-review-item-preview');
        if (preview && endTime >= 0) {
          const applyTime = function () {
            preview.currentTime = endTime;
            setActivePreview(wrapper);
          };
          if (preview.readyState >= 1) {
            applyTime();
          } else {
            preview.addEventListener('loadedmetadata', applyTime, { once: true });
          }
        } else {
          setActivePreview(wrapper);
        }
      } else {
        updateViewportAutoplay();
      }

      modalCarouselWrapper = null;
      resumeCarouselWrapper = null;
    }

    function playModalFromSavedTime() {
      function seekAndPlay() {
        if (modalStartTime > 0) {
          modalVideo.currentTime = modalStartTime;
        }
        modalVideo.play().catch(function () {});
      }

      if (modalVideo.readyState >= 1) {
        seekAndPlay();
      } else {
        modalVideo.addEventListener('loadedmetadata', seekAndPlay, { once: true });
      }
    }

    if (previewWrappers.length > 0) {
      const viewportObserver = new IntersectionObserver(
        function () {
          updateViewportAutoplay();
        },
        { threshold: [0, 0.25, 0.5, 0.75, 1] }
      );

      previewWrappers.forEach(function (w) {
        viewportObserver.observe(w);
        const video = w.querySelector('.video-review-item-preview');
        if (!video) return;
        video.addEventListener('loadedmetadata', updateViewportAutoplay);
        video.addEventListener('loadeddata', updateViewportAutoplay);
        video.addEventListener('webkitendfullscreen', function () {
          if (!isTouchPlaybackDevice()) return;
          cleanupMobilePreviewPlayback(video, w);
        });
      });

      document.addEventListener('fullscreenchange', handleDocumentFullscreenExit);
      document.addEventListener('webkitfullscreenchange', handleDocumentFullscreenExit);
      modalVideo.addEventListener('webkitendfullscreen', closeModalIfOpen);

      window.addEventListener('resize', updateViewportAutoplay, { passive: true });

      const splideEl = sectionRoot.querySelector(splideSelector);

      function bindSplideAutoplay(instance) {
        if (!instance) return;
        carouselSplide = instance;
        instance.on('moved', function () {
          resetMobileExpandedPreviews();
          requestAnimationFrame(updateViewportAutoplay);
        });
        instance.on('active', updateViewportAutoplay);
        updateViewportAutoplay();
      }

      if (splideEl && splideMountedEvent) {
        splideEl.addEventListener(splideMountedEvent, function (e) {
          bindSplideAutoplay(e.detail && e.detail.splide);
        });
        if (splideEl.splide) {
          bindSplideAutoplay(splideEl.splide);
        } else {
          var splidePoll = setInterval(function () {
            if (splideEl.splide) {
              clearInterval(splidePoll);
              bindSplideAutoplay(splideEl.splide);
            }
          }, 50);
          setTimeout(function () {
            clearInterval(splidePoll);
          }, 3000);
        }
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(updateViewportAutoplay);
      });
    }

    videoReviewLinks.forEach(function (link) {
      const wrapper = link.closest('.video-review-item-wrapper');
      const previewVideo = wrapper ? wrapper.querySelector('.video-review-item-preview') : null;

      if (previewVideo && canHoverPreview) {
        link.addEventListener('mouseenter', function () {
          viewportAutoplayEnabled = false;
          hoverLock = true;
          setActivePreview(wrapper);
        });

        link.addEventListener('mouseleave', function () {
          hoverLock = false;
        });
      }

      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clickedLink = this;
        modalCarouselWrapper = wrapper;

        const videoSrc = this.getAttribute('data-video-src') || this.getAttribute('href');
        const videoAlt = this.getAttribute('data-video-alt') || '';

        if (!videoSrc) return;

        if (isTouchPlaybackDevice()) {
          if (previewVideo) {
            openMobilePreviewPlayback(previewVideo, wrapper);
          } else {
            window.location.href = videoSrc;
          }
          return;
        }

        modalStartTime = previewVideo && Number.isFinite(previewVideo.currentTime) ? previewVideo.currentTime : 0;

        modalVideo.setAttribute('src', videoSrc);
        modalVideo.setAttribute('alt', videoAlt);
        modalVideo.load();

        const bsModal = bootstrap.Modal.getOrCreateInstance(modalEl);
        bsModal.show();
      });
    });

    modalEl.addEventListener('show.bs.modal', function (event) {
      if (isTouchPlaybackDevice()) {
        event.preventDefault();
        return;
      }

      sectionRoot.classList.add('is-video-modal-open');

      const trigger = event.relatedTarget || clickedLink;
      const triggerWrapper = trigger ? trigger.closest('.video-review-item-wrapper') : null;

      if (triggerWrapper) modalCarouselWrapper = triggerWrapper;
      resumeCarouselWrapper = getCarouselPlayingWrapper() || triggerWrapper;
      pauseAllCarouselPreviews();

      if (!trigger) return;

      const triggerPreview = triggerWrapper
        ? triggerWrapper.querySelector('.video-review-item-preview')
        : null;
      if (triggerPreview && Number.isFinite(triggerPreview.currentTime)) {
        modalStartTime = triggerPreview.currentTime;
      }

      const videoSrc = trigger.getAttribute('data-video-src') || trigger.getAttribute('href');
      const videoAlt = trigger.getAttribute('data-video-alt') || '';

      if (videoSrc) {
        modalVideo.setAttribute('src', videoSrc);
        modalVideo.setAttribute('alt', videoAlt);
        modalVideo.load();
      }
    });

    modalEl.addEventListener('shown.bs.modal', function () {
      if (isTouchPlaybackDevice()) {
        closeModalIfOpen();
        return;
      }
      playModalFromSavedTime();
    });

    modalEl.addEventListener('hidden.bs.modal', function () {
      const modalEndTime = Number.isFinite(modalVideo.currentTime) ? modalVideo.currentTime : 0;

      clickedLink = null;
      modalStartTime = 0;
      sectionRoot.classList.remove('is-video-modal-open');
      if (typeof modalVideo.pause === 'function') modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();
      resumeCarouselPreview(modalEndTime);
    });
  }

  function bootVideoReviewCarousels() {
    document.querySelectorAll('[data-video-review-carousel]').forEach(initVideoReviewCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVideoReviewCarousels);
  } else {
    bootVideoReviewCarousels();
  }
})();
